import React from 'react';
import { Link } from 'react-router-dom';

import './../../pagescss/Subjects.css';
import subjects from '../subjects/Subjects';
import TopNavbar from '../home/TopNavbar';
import TopHeader from '../home/TopHeader';
import UsePayments from '../AdminPanel/UsePayments';


function PracticeRamdomQuestion(props) {

  // Check payment
  const { allPayments, loading } = UsePayments();
  const userPhone = localStorage.getItem('userPhone');
 // const isPayment = allPayments.find(payment => payment.phone === userPhone);
  const isPayment = localStorage.getItem('userPayment');


  return (
    <div className="subject-page">

      <TopNavbar name="Practice random question " />
      <TopHeader name="Practice any question from any subject or topics" />




      <div className="subject-categories">

        {isPayment ? (<>
          <Link
            to={`/practice-random-question/${"all"}`}

            className="subject-card"
            style={{ borderLeft: `5px solid green` }}
          >
            <div className="subject-card-header">
              <div className="subject-icon" style={{ color: "green" }}>
                Δ
              </div>
              <h2>All Subjects ➔</h2>
            </div>
          </Link>

          {subjects.map((subject) => (
            <Link
              to={`/practice-random-question/${subject.name.toLowerCase().replace(' ', '-')}`}
              key={subject.id}
              className="subject-card"
              style={{ borderLeft: `5px solid ${subject.color}` }}
            >
              <div className="subject-card-header">
                <div className="subject-icon" style={{ color: subject.color }}>
                  {subject.icon}
                </div>
                <h2>{subject.name} ➔</h2>
              </div>
            </Link>
          ))}
        </>) : (<>
          <Link
            to="/premium-paywall"

            className="subject-card"
            style={{ borderLeft: `5px solid green` }}
          >
            <div className="subject-card-header">
              <div className="subject-icon" style={{ color: "green" }}>
                Δ
              </div>
              <h2>All Subjects ➔</h2>
            </div>
          </Link>

          {subjects.map((subject) => (
            <Link
              to="/premium-paywall"
              key={subject.id}
              className="subject-card"
              style={{ borderLeft: `5px solid ${subject.color}` }}
            >
              <div className="subject-card-header">
                <div className="subject-icon" style={{ color: subject.color }}>
                  {subject.icon}
                </div>
                <h2>{subject.name} ➔</h2>
              </div>
            </Link>
          ))}
        </>)}

      </div>

    </div>


  );
}

export default PracticeRamdomQuestion;